export default "__VITE_ASSET__Db3cqUq3__"